import PageTypeFactory from '../../page/get_page_type';
import GA_EVENTS from './ga_constants';
import { setBehaviourEvent } from './ga_interface';

class TyreSizeCalculatorAnalytics {
  static calculate() {
    const category = GA_EVENTS.tyreSizeCalculator.category;
    const action = GA_EVENTS.tyreSizeCalculator.actions.calculate;
    const label = PageTypeFactory.getPageType();

    setBehaviourEvent({ category, action, label });
  }

  static originalSize(formattedSize) {
    const category = GA_EVENTS.tyreSizeCalculator.category;
    const action = GA_EVENTS.tyreSizeCalculator.actions.originalSize;
    setBehaviourEvent({ category, action, label: formattedSize });
  }

  static newSize(formattedSize) {
    const category = GA_EVENTS.tyreSizeCalculator.category;
    const action = GA_EVENTS.tyreSizeCalculator.actions.newSize;
    setBehaviourEvent({ category, action, label: formattedSize });
  }
}
export default TyreSizeCalculatorAnalytics;